import { WINE_COLOUR } from "@proef/domain";
import { z } from "zod";
import { ELabel } from "./elabel.js";

/** The facts of a wine a user proposes for the catalogue; nothing about the user or their cellar. */
export const ProposalWine = z.object({
  producer: z.string().trim().min(1).max(200),
  name: z.string().trim().min(1).max(200),
  vintage: z.number().int().min(1800).max(2100).nullable().optional(),
  country: z.string().length(2).describe("ISO 3166-1 alpha-2"),
  colour: z.enum(WINE_COLOUR),
  sparkling: z.boolean().default(false),
  grapes: z.array(z.string().trim().min(1).max(100)).max(30).default([]),
  abvPercent: z.number().min(0).max(100).nullable().optional(),
});
export type ProposalWine = z.infer<typeof ProposalWine>;

/**
 * `POST /v1/proposals`: an explicit, opt-in suggestion to add a wine to the shared catalogue.
 * It carries the wine facts and, when the wine came from a scan, the e-label facts; never the
 * Scantrust proof, a device id or anything of the user's cellar or tastings.
 */
export const CatalogueProposal = z.object({
  wine: ProposalWine,
  elabel: ELabel.optional(),
});
export type CatalogueProposal = z.infer<typeof CatalogueProposal>;

/** `received` also answers a proposal already on file: the phone cannot tell the two apart, and need not. */
export const ProposalResponse = z.object({ status: z.literal("received") });
export type ProposalResponse = z.infer<typeof ProposalResponse>;

/** Max body of `POST /v1/proposals`, in bytes: the same ceiling as an e-label upload. */
export const PROPOSAL_MAX_BYTES = 65_536;
